import { LibraryImpact } from './types';

/**
 * The API answers 409 `LIBRARY_IN_USE` when publishing or rolling back would remove entries that
 * published forms select. Returns those details, or undefined for any other error.
 */
export const libraryImpact = (error: any): LibraryImpact | undefined => {
  const detail = error?.response?.data?.detail;
  return error?.response?.status === 409 && detail?.error === 'LIBRARY_IN_USE' ? detail : undefined;
};
